import { gql } from '@apollo/client'

import { USER_FRAGMENT } from '../fragments'

export const GET_USER = gql`
  query GetUser($id: ID!) {
    user(id: $id) {
      ...User
    }
  }
  ${USER_FRAGMENT}
`
